<script lang="ts">
  import { onMount, onDestroy } from "svelte";
  import CountUpStatItem from "$lib/molecules/CountUpStatItem.svelte";

  // Initialize the delivery stats state
  $: statsData = {} as Record<string, number>;
  let statsTimeout: ReturnType<typeof setTimeout>;
  let statsLoaded = false;

  /**
   * Fetches the delivery stats from the public stats endpoint
   */
  async function getStats() {
    try {
      const response = await fetch(
        "https://delivery-counter.platform.flyzipline.com/api/v1/public/stats/",
      );

      // Get the stats data and show the count
      statsData = await response.json();
      statsLoaded = true;

      // Refresh the count data every x seconds
      statsTimeout = setTimeout(() => {
        getStats();
      }, 2000);
    } catch (error) {
      console.error("Error fetching delivery stats:", error);
    }
  }

  onMount(() => {
    getStats();
  });

  onDestroy(() => {
    if (statsTimeout) {
      clearTimeout(statsTimeout);
    }
  });
</script>

{#if statsLoaded}
  <CountUpStatItem value={statsData.num_deliveries} />
{/if}
